import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLazyGetCompanyListQuery } from "../../../../redux/api/chemicalization/companyApi";
import { Contact, EntCompany } from "../../../../models/chemicalization/company";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useCompany } from "./useCompany";
import { FilterCompany } from "./FilterCompany";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { AddCompany } from "./AddCompany";
import { EntCompanyFilter } from "../../../../models/filters/companyFilter";
import { DeleteContactModal } from "./DeleteContactModal";


enum FormField {
  companyName,
}


export const Company = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedFarmOwner, setSelectedFarmOwner] = useState<EntCompany>(new EntCompany());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()
  const [showContactsModal, setShowContactsModal] = useState<boolean>(false);
  const [selectedContacts, setSelectedContacts] = useState<Contact[]>([]);


  const [getArchiveFolders] = useLazyGetCompanyListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntCompany, EntCompanyFilter>({
	initialFilter: new EntCompanyFilter(),
	query: getArchiveFolders
  });

  const { onAddCompany, onDeleteCompany, onEditCompany } = useCompany(modal, () => {
	searchHandleClick();
  })

  const [height, setHeight] = useState<number>(0);

  const openAddModal = (item: EntCompany) => {
	setSelectedFarmOwner(item);
	setShowModal(true);
  }

  const viewContacts = (company: EntCompany) => {
	setSelectedContacts(company.contacts || []);
	setShowContactsModal(true);
  };

  const setEntityFromFields = (): EntCompanyFilter => {
	let filt: EntCompanyFilter = _.clone(filter);
	filt.companyName = form.getFieldValue(FormField.companyName) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.companyName, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }
  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th style={ { width: "200px" } }>{ t('titles.company') }</th>
		  <th style={ { width: "200px" } }>{ t('chemicalization.company.total_fertilizer') }</th>
		  <th style={ { width: "180px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.companyName }</td>
			<td>{ item?.totalFertilizer }</td>
			<td>
			  <Flex gap="small">

				<Tooltip title={ t('contact') }>
				  <Button
					className="btn_edit"
					type="primary"
					onClick={ () => viewContacts(item) }
				  >
					{ t('chemicalization.company.view_contacts') }
				  </Button>
				</Tooltip>
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button
					  className="btn_edit"
					  onClick={ () => {
						openAddModal(item);
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <EditOutlined/> }
					/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button
					  className="btn_edit"
					  danger
					  onClick={ () => {
						onDeleteCompany(item);
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <DeleteOutlined/> }
					/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.company') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('chemicalization.company.companyDesc') } { t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntCompany)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterCompany onSearch={ searchHandleClick }
								onReset={ () => {
								  clearFields();
								  searchHandleClick()
								} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }

	  />
	  <AddCompany
		company={ selectedFarmOwner }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedFarmOwner.id !== null ? onEditCompany : onAddCompany }
	  />
	  <DeleteContactModal
		visible={ showContactsModal }
		onClose={ () => setShowContactsModal(false) }
		contacts={ selectedContacts }
	  />
	  { contextHolder }
	</>
  )
}
